import { z } from 'zod';
import { $CandidateProfile } from './CandidateProfile';
import { $CandidateRole } from './CandidateRole';

export const $CandidateUser = z.object({
  id: z.number(),
  email: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  vacanciesCount: z.number(),
  role: $CandidateRole,
  profile: $CandidateProfile,
  company: z.string(),
  vacancies: z.array(z.string()),
});
